import Vue from 'vue'
import axios from 'axios'
let url = ''
switch(process.env.NODE_ENV) {
    case 'production':
        url = 'http://www.storlead.com/zh-CN/user.html#/login'
      break
    case 'development':
      url = '#/login'
      break
    case 'test':
        url = 'http://test.storlead.com/zh-CN/user.html#/login'
        break
}
// axios 配置
axios.defaults.timeout = 100000
// axios.defaults.baseURL = 'https://api.github.com';
Vue.prototype.Ajax = axios
// Add a request interceptor 请求
axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // console.log(config)
    // Vue.prototype.$Loading.start()
    // console.log(config)
    config.headers = {Pragma: 'no-cache'}
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

// http response 拦截器 errorCode
axios.interceptors.response.use(
    response => {
        // Vue.prototype.$Loading.finish()
        let data = response.data
        return data
    },
    error => {
        // console.error('>>>>>>>>>response>>>>>>>>>');
        // console.error(error.response);

        return Promise.reject(error)
        // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
        // return Promise.reject(error.response.data)
    }
)
const uA = window.navigator.userAgent
const isIE = /msie\s|trident\/|edge\//i.test(uA) && !!("uniqueID" in document || "documentMode" in document || ("ActiveXObject" in window) || "MSInputMethodContext" in window)

const URL = process.env.NODE_ENV == 'development' ? '/web' : '/spweb'
export default {
    Get(url, params, fn, errorFn) {
        axios.get(URL + url, {params: params}).then(fn).catch(errorFn)
    },
    Post(url, params, fn) {
        axios.post(URL + url, params).then(fn).catch(err => console.error(err))
    },
    Delete(url, params, fn) {
        axios.delete(URL + url, {params: params}).then(fn).catch(err => console.error(err))
    },
    uploadImg: URL + '/file/upload_pic',    //上传图片接口
    uploadFile: URL + '/file/upload_file',    //上传文件接口，不用登录的
    uploadTemplateFile: URL + '/userQuotation/uploadQuotation/',    //上传文件接口，不用登录的
    DownExcel(url, name) {
        console.log(this)
        axios({
            method: 'get',
            url: URL + url,
            responseType: 'blob'
        }).then(data => {
            if(!data){
                return
            }
            var blob = new Blob([data], {type: data.type})
            var url = window.URL.createObjectURL(blob);
            var aLink = document.createElement("a");
            aLink.style.display = "none";
            aLink.href = url;
            aLink.setAttribute("download", "template.xlsx");
            document.body.appendChild(aLink);
            aLink.click();
            document.body.removeChild(aLink); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
        })
    },
    //下载文件

    Down(url, name, type="application/pdf") {
        axios({
            method: 'get',
            url: URL + url,
            responseType: 'blob'
        }).then(data => {
            if (!data) return
            if (isIE) {
                var blob = new Blob([data], {type: type})
                if (window.navigator && window.navigator.msSaveOrOpenBlob) { // for IE
                    window.navigator.msSaveOrOpenBlob(blob, name)
                }
            } else {
                let url = window.URL.createObjectURL(new Blob([data]))
                let link = document.getElementById('download')
                link.href = url
                // link.target = "_blank"
                link.setAttribute('download', name)
                link.click()
                console.log(data)
            }

        }).catch(err => console.error(err))
    }
}

